<cube-side>
    <div class="container" style="min-height: calc(100vh - 50px); padding-top: 100px; padding-bottom: 100px; text-align: left;">
        <a href="/assets/img/me.jpg" class="glightbox"><img class="textImage" src="assets/img/me.jpg" /></a>
        <b class="shadowed">Hello!</b> I am Jakob, hobby-pianist, juggler and computer enthusiast. On this page I just want to tell you a little bit about me and show you who I am.
        <br><br>
        <b class="shadowed">One thing first</b>: Use the menu (top right)! I guess you've never seen anything like it before...<br><br>
        <b class="shadowed">And now</b> explore! (Or learn more <a class="link" routerLink="/aboutme">about me</a>)
    </div>
</cube-side>
